<template>
  <el-container class="login" style="display: table-cell" v-title data-title="佳效安防-登录">
    <el-form ref="form" :model="loginForm" label-width="80px" class="login-form">
      <el-col :span="24" style="text-align: center; margin: 20px auto; font-size: 30px; color: #CCC">签到系统管理平台</el-col>
      <el-form-item v-show="!showQr" label="用户名">
        <el-input v-model="loginForm.userName" style="width: 220px"></el-input>
      </el-form-item>
      <el-form-item v-show="!showQr" label="密码">
        <el-input v-model="loginForm.password" type="password" style="width: 220px"></el-input>
      </el-form-item>
      <el-form-item v-show="!showQr" label="用户类型" size="small">
        <el-radio-group v-model="loginForm.userType" style="margin-left: 13px">
          <el-radio-button :disabled="userTypeDisable" label="2" key="2">教职员</el-radio-button>
          <el-radio-button :disabled="userTypeDisable" label="4" key="4">家&nbsp;&nbsp;长</el-radio-button>
          <el-radio-button :disabled="userTypeDisable" label="1" key="1">管理员</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-col v-show="showQr" :span="24" style="text-align: center">
        <img width=180 style="margin-top: -4px" :src="qrLoginCode" />
      </el-col>
      <el-button v-show="!showQr" type="primary" plain style="margin-left: 12px; width: 95px" @click="showQr = true">扫码登录</el-button>
      <el-button v-show="!showQr" type="primary" style="margin-left: 20px; width: 110px" @click="login">登&nbsp;&nbsp;录</el-button>
      <el-button v-show="showQr" type="primary" plain style="margin-left: 12px; width: 138px" @click="showQr = false">返回到账号登录</el-button>
    </el-form>
    <div style="position: fixed; bottom: 0; width: 100%; height: 25px; padding: 0; text-align: right;">
      <img style="vertical-align: middle;" src="../assets/beianbgs.png"
       alt="" width="25" height="25">
      <a style="vertical-align: middle; font-size: 13px; color: #444" href="https://beian.miit.gov.cn" target="_blank">浙ICP备16047163号-4</a>
      <span style="vertical-align: middle; font-size: 13px; color: #444">版权所有：杭州佳效安防科技有限公司</span>
    </div>
  </el-container>
</template>

<script>
export default ({
  data () {
    return {
      loginForm: {
        userName: '',
        password: '',
        userType: '2'
      },
      qrLoginState: '',
      qrLoginCode: '',
      qrState: '',
      showQr: false,
      timer: null,
      websock: null
    }
  },
  computed: {
    userTypeDisable () {
      return !/^\d{11}$/.test(this.loginForm.userName)
    }
  },
  mounted () {
    this.getTime()
    // this.getQrLoginCode()
  },
  created () {
    let _this = this
    document.onkeydown = function (e) {
      if (window.event.keyCode === 13) {
        _this.login()
      }
    }
    this.initWebSocket()
  },
  destroyed () {
    // if (this.timer) {
    //   clearInterval(this.timer)
    // }
    this.websock.close()
  },
  methods: {
    getTime () {
      this.$axios.get(this.GLOBAL.host + '/time').then(res => {
        if (res.data && res.data.status === 200 && res.data.data) {
          this.Cookie.set('offsetSecond', parseInt(res.data.data) - Math.round(new Date().getTime() / 1000))
        }
      })
    },
    login () {
      let _this = this
      if (this.loginForm.userName === '' || this.loginForm.password === '') {
        this.$message.warning('账号或密码不能为空')
        return
      }
      this.$axios.get(this.GLOBAL.host + '/user/auth', {
        params: {
          userName: this.loginForm.userName,
          password: this.loginForm.password,
          userType: this.loginForm.userType
        }
      }).then(res => {
        if (res.data) {
          if (res.data.status === 200) {
            _this.Cookie.set('userInfo', JSON.stringify(res.data.data))
            if (res.data.data.userType === '1') {
              _this.$router.push('/student')
            } else if (['2', '4'].indexOf(res.data.data.userType) !== -1) {
              _this.$router.push('/student')
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    // waiting for qrcode login
    // getQrLoginCode () {
    //   let _this = this
    //   this.$axios.post(this.GLOBAL.host + '/getQrLoginCode').then(res => {
    //     if (res.data) {
    //       if (res.data.status === 200 && res.data.data != null && res.data.data.qrLoginState != null && res.data.data.qrLoginCode != null) {
    //         console.log(res.data.data)
    //         _this.qrLoginState = res.data.data.qrLoginState
    //         _this.qrLoginCode = res.data.data.qrLoginCode
    //         // if (_this.timer) {
    //         //   clearInterval(_this.timer)
    //         // } else {
    //         //   _this.timer = setInterval(() => {
    //         //     _this.checkQrLoginCode()
    //         //   }, 3000)
    //         // }
    //       } else {
    //         this.$message.error(res.data.message)
    //       }
    //     }
    //   })
    // },
    // checkQrLoginCode () {
    //   let _this = this
    //   console.log(_this.qrLoginState)
    //   this.$axios.post(this.GLOBAL.host + '/wechat/checkQrLogin',
    //     this.$qs.stringify({
    //       state: _this.qrLoginState
    //     })
    //   ).then(res => {
    //     if (res.data) {
    //       console.log(res.data.data)
    //       if (res.data.status === 200) {
    //         _this.Cookie.set('userInfo', JSON.stringify(res.data.data))
    //         if (res.data.data.userType === '1') {
    //           _this.$router.push('/student')
    //         } else if (['2', '4'].indexOf(res.data.data.userType) !== -1) {
    //           _this.$router.push('/student')
    //         }
    //       }
    //     }
    //   })
    // },
    initWebSocket () {
      // 初始化weosocket
      this.websock = new WebSocket(this.GLOBAL.wsHost)
      this.websock.onopen = this.websocketonopen
      this.websock.onmessage = this.websocketonmessage
      this.websock.onerror = this.websocketonerror
      this.websock.onclose = this.websocketclose
    },
    websocketonopen () {
      // 连接建立之后执行send方法发送数据
      this.websocketsend('getQrLoginCode')
    },
    websocketonerror () {
      // 连接建立失败重连
      this.initWebSocket()
    },
    websocketonmessage (e) {
      // 数据接收
      console.log('receive message: ' + e.data)
      if (e.data != null) {
        if (e.data.substring(0, 16) === 'sendQrLoginCode_') {
          let message = JSON.parse(e.data.substring(16))
          if (message != null && message.qrLoginState != null && message.qrLoginCode != null) {
            this.qrLoginState = message.qrLoginState
            this.qrLoginCode = message.qrLoginCode
          }
        } else if (e.data.substring(0, 15) === 'qrLoginSuccess_') {
          let userInfo = JSON.parse(e.data.substring(15))
          if (userInfo != null && userInfo.id != null && userInfo.userType != null) {
            this.Cookie.set('userInfo', JSON.stringify(userInfo))
            if (userInfo.userType === '1') {
              this.$router.push('/student')
            } else if (['2', '4'].indexOf(userInfo.userType) !== -1) {
              this.$router.push('/student')
            }
          }
        }
      }
      // console.log(e.data)
      // let redata = JSON.parse(e.data)
      // console.log(redata)
    },
    websocketsend (Data) {
      // 数据发送
      this.websock.send(Data)
    },
    websocketclose (e) {
      // 关闭
      console.log('断开连接', e)
    }
  }
})
</script>
<style>
html, body, #app {
  height: 100%;
}
#app {
  display: table;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
.login {
  display: table-cell;
  vertical-align: middle;
  /* background-image: linear-gradient(30deg, blue, green); */
  background-image: url(../assets/login_bg.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover
}
.login-form {
  width: 350px;
  height: 350px;
  margin-left: auto;
  margin-right: auto;
  padding: 215px;
  padding-left: 189px;
  /* border-style: ridge; */
  /* border-width: 70px; */
  /* border-color: rgba(255,255,255,0.1) transparent; */
  background-image: url(../assets/login_form_bg.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover
}

</style>



// WEBPACK FOOTER //
// src/components/Login.vue